import { render, staticRenderFns } from "./createAlarm.vue?vue&type=template&id=58f57240&"
import script from "./createAlarm.vue?vue&type=script&lang=js&"
export * from "./createAlarm.vue?vue&type=script&lang=js&"
import style0 from "./createAlarm.vue?vue&type=style&index=0&id=58f57240&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports